import {GA_DISABLED} from "./Constants";

export const GAEventActions = {
    CALL_MODEL: 'call_model',
    VIEW_MODEL: 'view_model',
};

export const GAEventModels = {
    ARTICLE_KEYWORDS: 'article_keywords',
    ARTICLE_SUMMARIZER: 'article_summarizer',
    AVATAR_GENERATOR: 'avatar_generator',
    CHATBOT: 'general_bot',
    CROSS_PROVIDER: 'cross_provider',
    EXPOSURE_ANALYZER: 'exposure_analyzer',
    FACE_DETECTION: 'azure_face_api',
    FACE_RECOGNITION: 'face_recognition',
    FACE_RESTORATION: 'face_restoration',
    FEAR_AND_GREED_INDEX: 'fear_and_greed_index',
    DEEPFAKE_DETECTION: 'deepfake_detection',
    TEXT2ART: 'text2art',
    GRAMMAR_BOT: 'grammar_bot',
    HEDGING_TOOL: 'hedging_tool',
    IMAGE_CONTENT: 'azure_content_moderation',
    IMAGE_LABELING: 'image_labeling',
    MEME_GENERATOR: 'meme_generator',
    JOKES: 'jokes',
    NAMED_ENTITY_RECOGNITION: 'named_entity_recognition',
    PARAPHRASING_TOOL: 'paraphrasing_tool',
    QUESTION_ANSWERING: 'question_answering',
    REDDIT_POSTS: 'reddit_posts',
    SOCIAL_SENTIMENT: 'social_sentiment',
    SUMMARIZER: 'summarizer',
    SPEECH_RECOGNITION: 'speech_recognition',
    TEXT_COMPLETION: 'text_completion',
    TEXT_EMOTION: 'text_emotion',
    TEXT_EXTRACTION: 'text_extraction',
    TEXT_GENERATION: 'text_generation',
    TEXT_SENTIMENT: 'text_sentiment',
    TEXT_SIMILARITY: 'text_similarity',
    TEXT_SUMMARIZER: 'text_summarizer',
    TEXT_TO_SPEECH: 'text_to_speech',
    TRANSLATION: 'translation',
    TRIP_PURPOSE: 'trip_purpose',
    VIDEO_TO_TEXT: 'video_to_text',
    VISION_AI: 'google_vision_ai',
    WEATHER: 'weather_api',
};

function SendGAEvent (action, model) {
    if (GA_DISABLED) {
        return;
    }

    const gtag = window.gtag;
    if (gtag) {
        gtag('event', action, {
            'event_category': 'engagement',
            'event_label': [action, model].join('_'),
            'model_name': model,
            'non_interaction': false
        });
    }
}

export default SendGAEvent;


// WEBPACK FOOTER //
// ./src/utils/SendGAEvent.js